module.exports = __webpack_public_path__ + "img/accessibility.56cc8084.svg";